module.exports = __webpack_public_path__ + "media/lymphoid hyperplasia.f96d0c5a.wav";